export interface IExpertSystemRegistration {
    registrationId: number;
    donorId: number;
    recipientId: number;
    expertSystemId: number;
    centerId: number;
    donorFirstName: string;
    donorLastName: string;
    donorGender: string;
}
